/** Starts the MSW worker when VITE_USE_MOCKS=true (loaded lazily, so production bundles don't include it). */
export async function maybeStartMocks(): Promise<void> {
  if (import.meta.env.VITE_USE_MOCKS !== 'true') return;
  const { startMockWorker } = await import('@missions/mocks/browser');
  await startMockWorker({ serviceWorkerUrl: `${import.meta.env.BASE_URL}mockServiceWorker.js` });
}
